export default "__VITE_ASSET__DsnxaNxr__"